import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import Slider from "react-slick";

import FloorplanCustomiser from "../components/FloorplanCustomiser";
import FloorplanLightbox from "../components/FloorplanLightbox";
import GoogleMap from "../components/GoogleMap";
import Icon from "../components/Icon";
import MoreDetailsBtn from "../components/MoreDetailsBtn";
import { ApiContext, NavigationContext, UserContext } from "../contexts";
import { FloorplanOption, IconName } from "../types";
import { scrollToTop } from "../util";

const slickSettings = {
  infinite: true,
  arrows: true,
  dots: false,
  centerMode: true,
  variableWidth: true,
  touchThreshold: 500,
  className: "gallery-slider",
  responsive: [
    {
      breakpoint: 991,
      settings: {
        variableWidth: false,
        centerMode: false,
        arrows: false,
      },
    },
  ],
};

const HouseLandDetailsScreen = observer(() => {
  const userContext = useContext(UserContext);
  const apiContext = useContext(ApiContext);
  const navContext = useContext(NavigationContext);

  const [lightboxSvg, setLightboxSvg] = useState("");
  const [isLightboxShown, setIsLightboxShown] = useState(false);

  useEffect(() => {
    scrollToTop();
    navContext.setFooterModePrimary();
    navContext.setNextBtnText("Select Package");
    navContext.setNextButtonEnabled(true);
    navContext.setOnNavigateBack(() => {
      userContext.resetSelectedFloorplanOptions();
      userContext.resetIsFloorplanFlipped();
    });

    // If the user entered the app via a House link on the main website,
    // we need to pre-select the floorplan options for the home design
    if (
      apiContext.enteredViaHome &&
      userContext.selectedHouseLand &&
      apiContext.enteredViaHome.id === userContext.selectedHouseLand.home_id &&
      !userContext.selectedFloorplanOptions.get(
        userContext.selectedHouseLand.id
      ) &&
      userContext.selectedFloorplanOptions.get(apiContext.enteredViaHome.id)
    ) {
      userContext.setSelectedFloorplanOptions(
        userContext.selectedHouseLand.id,
        userContext.selectedFloorplanOptions.get(
          apiContext.enteredViaHome.id
        ) || []
      );
    }
    return () => {
      // Unbind the handler when we unmount
      navContext.resetOnNavigateBack();
    };
  }, []);

  const onClickBack = () => {
    navContext.goBack();
  };

  const onClickPdf = () => {
    if (userContext.selectedHouseLand) {
      const url = `/house-and-land-packages/${userContext.selectedHouseLand.slug}/pdf`;
      window.open(url, "_blank");
    }
  };

  const onClickGetDirections = () => {
    if (userContext.selectedHouseLand) {
      const h = userContext.selectedHouseLand;
      const address = `${h.address} ${h.suburb} ${h.state} ${h.postcode} Australia`;
      const url =
        "https://www.google.com/maps/search/?api=1&query=" + encodeURI(address);
      window.open(url, "_blank");
    }
  };

  const onClickShowLightbox = (svg: string) => {
    // The user can click the lightbox link on the next item in the carousel on desktop
    setLightboxSvg(svg);
    setIsLightboxShown(true);
  };

  const onClickFloorplanOption = (option: FloorplanOption) => {
    if (userContext.selectedHouseLand) {
      userContext.toggleSelectedFloorplanOption(
        userContext.selectedHouseLand.id,
        option
      );
    }
  };

  const onFlipFloorplan = (isFlipped: boolean) => {
    if (userContext.selectedHouseLand) {
      userContext.setIsFloorplanFlipped(
        userContext.selectedHouseLand.id,
        isFlipped
      );
    }
  };

  return (
    <div className={"screen screen-house-land-details"}>
      
    </div>
  );
});

export default HouseLandDetailsScreen;
